exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divFilter[data-v-dd951ef8]{position:absolute;left:0;width:300px;background-color:#e6f2fd;min-height:80px;z-index:9999;padding:5px;border-radius:5px;box-shadow:0 0 5px rgb(0 0 0/40%)}.radioFinal[data-v-dd951ef8]{margin-right:23px;font-size:12px;font-weight:400;margin-top:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd951ef8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/ListDocInfo/Components/ChangeStatusDoc.vue
// module id = 539
// module chunks = 0